import { getFullScreenSize } from "@/utils/layout";
import ModalBaseContainer from '@max/leez-modal-base-container';
import View from '@hfe/max-view';
import Text from '@hfe/max-text';
import LImage from '@max/leez-image';
import TopView from '@max/leez-top-view';
import { convertCentsToYuan, formatDate, MTNewDigitalDisplayStyle } from "@/utils/common";
import './index.scss';
import VapView from "../vap-view";
import { FREE_CARD_VAP } from "@/const";
import { Animated } from '@max/mbc-animated';
import AnimatedView from '@max/mbc-animate-view';
import { useRef, createElement } from "@max/max";
import { isTitansAppOrWebview } from "@nibfe/mkt-env-api";
import ModalBottomBtn from "../modal-bottom-button";
export default function FreeCardDrawResultPopup(props) {
    const { needAnimation = true } = props;
    const { fullScreenHeight, fullScreenWidth, toRateSize } = getFullScreenSize();
    const opacity = useRef(new Animated.Value(0));
    const amountTranslateY = useRef(new Animated.Value(toRateSize(140)));
    const opacityValue = needAnimation ? opacity.current : 1;
    const amountTranslateYValue = needAnimation ? amountTranslateY.current : 0;
    if (!props.freeOrderCardExtra) {
        return null;
    }
    const { hotelName, obtainAmount } = props.freeOrderCardExtra;
    const Container = needAnimation ? View : LImage;
    return <TopView>
      <ModalBaseContainer visible={props.visible} contentStyle={{
        width: '750rpx',
        height: fullScreenHeight,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        position: 'relative'
    }}>
        <VapView x-if={needAnimation} {...FREE_CARD_VAP} isFullScreen widthHeightRatio={750 / 1642} height={fullScreenHeight} width={fullScreenWidth} style={{
        bottom: 0,
        left: 0,
        position: 'absolute'
        // justifyContent: 'flex-start',
    }} keepLastFrame loop={false} playPointActions={[{
            microseconds: isTitansAppOrWebview() ? 2500 : 3200,
            action: () => {
                Animated.spring(amountTranslateY.current, {
                    toValue: toRateSize(0),
                    useNativeDriver: true,
                    stiffness: 100,
                    damping: 10,
                    mass: 1,
                    overshootClamping: false,
                    restDisplacementThreshold: 0.01,
                    restSpeedThreshold: 2
                }).start();
            }
        }, {
            microseconds: isTitansAppOrWebview() ? 3400 : 3800,
            action: () => {
                Animated.timing(opacity.current, {
                    toValue: 1,
                    duration: 400,
                    useNativeDriver: true,
                    easing: Animated.Easing.bezier(0.25, 0.1, 0.25, 1.0)
                }).start();
            }
        }]}/>
        
        <Container source={{
        uri: 'https://p0.meituan.net/ingee/d4ce31ef2580b835b9d58796ebf75f49376514.png'
    }} style={{
        width: '750rpx',
        height: fullScreenHeight,
        display: 'flex',
        // paddingTop: needAnimation ? '318rpx' : '50rpx',
        overflow: 'visible',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        position: 'relative'
    }}>
          
          <View className="free-card-main-container">
            <AnimatedView viewId="free-card-main-container" style={{
        opacity: opacityValue
    }}>
              
              <Text className="free-card-order-info" numberOfLines={1}>
                订单：{hotelName}
              </Text>

              
              <Text className="free-card-date">
                {formatDate(props.freeOrderCardExtra.checkOutTime).hanStr}
              </Text>
            </AnimatedView>

            
            <View className="free-card-tag" style={{
        opacity: needAnimation ? 0 : 1
    }}>
              <View className="free-card-tag-icon">
                <Text className="free-card-tag-text">免</Text>
              </View>
              <Text className="free-card-tag-desc">1房1晚·实付价</Text>
            </View>

            
            <View style={{
        overflow: 'hidden'
    }}>
              <AnimatedView className="free-card-amount-container" viewId="free-card-amount" style={{
        transform: [{
                translateY: amountTranslateYValue
            }]
    }}>
                <Text className="free-card-amount-symbol" style={MTNewDigitalDisplayStyle}>¥</Text>
                <Text className="free-card-amount-value" style={MTNewDigitalDisplayStyle}>
                  {convertCentsToYuan(obtainAmount || 0, 2).integerPart}
                </Text>
                <Text className="free-card-amount-symbol" style={MTNewDigitalDisplayStyle}>.{convertCentsToYuan(obtainAmount || 0, 2).decimalPart}</Text>
              </AnimatedView>
            </View>

            
            <AnimatedView viewId="free-card-tip" style={{
        opacity: opacityValue
    }}>
              <Text className="free-card-tip">
                {props.freeCardDesc}
              </Text>
            </AnimatedView>

            
            <AnimatedView viewId="free-card-share-btn" style={{
        opacity: opacityValue,
        marginTop: '70rpx'
    }}>
              <ModalBottomBtn buttonText="分享好运" onPress={props === null || props === void 0 ? void 0 : props.onShareFreeCard}/>
            </AnimatedView>
          </View>

          
          <AnimatedView viewId="free-card-close-btn" style={{
        opacity: opacityValue
    }}>
            <LImage onPress={props.onClose} source={{
        uri: 'https://p0.meituan.net/ingee/94047ffc6fa8ede65644e7a2653da1691779.png'
    }} style={{
        width: '48rpx',
        height: '48rpx',
        marginTop: '60rpx'
    }} className="free-card-close-btn"/>
          </AnimatedView>
        </Container>

      </ModalBaseContainer>
    </TopView>;
}
